import type { SxProps, Theme } from '@mui/material/styles';

/**
 * When the label is rendered outside the field (caption above), MUI can still leave a
 * notched outline gap. Select fixes this in `select.tsx` for `!inputLabel`; DatePicker
 * must merge this when there is no `label` on the picker field.
 *
 * Do not put this in the global theme: it breaks fields that use a floating `label`.
 */
const textFieldNoFloatingLabelOutlineSx: SxProps<Theme> = {
    '& .MuiOutlinedInput-notchedOutline': {
        top: 0,
        '& legend': {
            display: 'none',
        },
    },
};

/** Caption-above fields: same top border as `MuiSelect` with `!inputLabel` (see `select.tsx`). */
export const noFloatingLabelOutlinedFieldSx = textFieldNoFloatingLabelOutlineSx;

export function mergeOutlinedFilterFieldSx(
    userSx: SxProps<Theme> | undefined,
    options: { hasFloatingLabel: boolean }
): SxProps<Theme> | undefined {
    if (options.hasFloatingLabel) {
        return userSx ?? undefined;
    }
    if (userSx == null) return textFieldNoFloatingLabelOutlineSx;
    return Array.isArray(userSx)
        ? [textFieldNoFloatingLabelOutlineSx, ...userSx]
        : [textFieldNoFloatingLabelOutlineSx, userSx];
}
